import { SET_INTERNAL_TRANSITION } from '../../constants/history';

export const setInternalTransition = () => ({ type: SET_INTERNAL_TRANSITION });
